import React, { Component } from 'react';
import {connect} from 'react-redux';
import config from  '../../config';
import {bindActionCreators} from 'redux';
import {   makeRequest ,dispatchAction,displayMessage   }  from 'actions';
import {  USER_LOGOUT, UPDATE_APP_DATA} from 'actions/actionTypes';
import { fetchSettings } from 'shared/sharedMethods';
 class Dashboard extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }
    constructor(props, context) {
        super(props, context);
        this.state = {
            accessNotAllowed:false
        };
    };
    componentWillMount() {
      fetchSettings.call(this,'FeatureFlags').then(result => {
        this.props.dispatchAction({
         FeatureFlags:result,
        }, UPDATE_APP_DATA);
      }).catch(err=>{
        console.log('server error', err  );
      });
         this._displayAccessNotAllowedMessage = _.debounce(this._displayAccessNotAllowedMessage, 1000  );
        this.checkPermissions(this.props);
    }

    checkIfUserCanAccessResources(properties){

        var matchedResources =_.filter(config.rolesToResourcesAccessMap,(item, resource)=>{

            var pathMatched = false
            if (item.pathToMatch && !_.isArray(item.pathToMatch)){/* if pathToMatch  is undefined, it can be matched by any resource, so need to exclude it*/
                 item.pathToMatch = [item.pathToMatch]
            }
            _.forEach(item.pathToMatch, pathToMatch=>{
                var re = new RegExp(pathToMatch, "g");
                if (re.test(properties.location.pathname)){
                    pathMatched = true
                }
            })
            if (pathMatched ){
                 if (_.size(_.intersection(properties.userReducer.user.Roles, item.AllowedRoles))){
                    return true
                }
                if (_.includes(_.get(properties.userReducer.user,'ResourceAccessRights',[]), resource)) {
                     return true
                }
                var allowedRoleData =resource.split('_');
                  if (allowedRoleData.length ==3){
                     allowedRoleData = [allowedRoleData[0]+'_'+allowedRoleData[1], allowedRoleData[2]]
                 }
                 if (_.includes(_.get(properties.userReducer.user,'ResourceAccessRights',[]), resource)) {

                    return true
                }else if(allowedRoleData[1] == 'view'){ /* if _view role is allowed, _edit and _full roles are also allowed*/
                    if (_.size(_.intersection([allowedRoleData[0]+'_edit',allowedRoleData[0]+'_full'],_.get(properties.userReducer.user,'ResourceAccessRights',[])))) {
                        return true
                    }
                }  else if(allowedRoleData[1] == 'edit'){
                    if (_.size(_.intersection([ allowedRoleData[0]+'_full'],_.get(properties.userReducer.user,'ResourceAccessRights',[])))) {
                        return true
                    }
                }
                 return false
            }
        })
          if (!_.size(matchedResources)){
          if (_.size(_.intersection(properties.userReducer.user.Roles, [  'Wingmom', 'Ops Manager', 'Product Manager',  'Administrator'])) ) {
               return {'messageCode': properties.location.pathname =='/admin'? '': 'errorAccessResource', 'redirect': '/admin/reports'}
         }else if (_.size(_.intersection(properties.userReducer.user.Roles, [ 'Financial Analyst', ])) ) {
                 return {'messageCode':properties.location.pathname =='/admin'? '': 'errorAccessResource', 'redirect': '/admin/products'}
        }else{
              return {'messageCode': 'errorAccessResource', 'redirect': '/login'}

          }
       }

    }
    checkPermissions(properties) {
        var accessNotAllowed = false;
         if (!properties.userReducer.token) {
            accessNotAllowed = {'messageCode': 'errorAccessResource', 'redirect': '/login'}
        } else if (_.size(_.intersection(properties.userReducer.user.Roles, [  'Wingmom', 'Ops Manager', 'Product Manager',  'Financial Analyst', 'Administrator'])) == 0) {
            accessNotAllowed = {'messageCode': 'errorAccessResource', 'redirect': '/'}
        }

        accessNotAllowed = this.checkIfUserCanAccessResources(properties)
           if (accessNotAllowed) {
            this.setState({'accessNotAllowed':true}, function () {
                if (accessNotAllowed.messageCode) {
                    setTimeout(function () {
                        this._displayAccessNotAllowedMessage(accessNotAllowed.messageCode);
                    }.bind(this), 1000);
                }
                if (_.size(_.intersection(properties.userReducer.user.Roles, [  'Wingmom', 'Ops Manager', 'Product Manager', 'Financial Analyst',  'Administrator']))){
                     this.context.router.push(accessNotAllowed.redirect);
                   this.setState({'accessNotAllowed':false})  /* so that Dashboard can render after user is redirected*/
                } else{
                    this._displayAccessNotAllowedMessage(accessNotAllowed.messageCode);
                    setTimeout(function () {
                        window.top.location.href =  config.getEnvironment().clientSideURL
                    }.bind(this), 2500);
                }
            });
        }
    }
    _displayAccessNotAllowedMessage(message){
        return this.props.displayMessage({
            'messageType': 'warning',
            'messageCode': message
        });
    }




    componentWillReceiveProps(nextProps) {
            if (this.props.userReducer.token && !nextProps.userReducer.token) { /* after log out */
                return  this.setState({'accessNotAllowed':true}, function () {
                    return this.context.router.push('/login');
                });
            }
            this.checkPermissions(nextProps)
     }
    logoutUser(){
       this.props.dispatchAction({}, USER_LOGOUT)
         this.context.router.push('/login');
    }

    render() {
         if (this.state.accessNotAllowed){
            return null;
        }

         if(this.props.appData.FeatureFlags.initialData) {
           return null;
         }
             return (
                <div className="dashboard">
                    <div className="container">{this.props.children}</div>
                </div >
            );
    }
}

function mapStateToProps(state, ownProps) {
    return { userReducer: state.userReducer,
      appData: state.appData,
        currentURL: ownProps.location}
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({makeRequest,dispatchAction,displayMessage}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps )(Dashboard);